import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const createColumn = (field, headerName) => ({
  flex: 1,
  field,
  headerName,
  renderCell: renderCellExpand,
});
